// src/pages/About/About.js
import React from 'react';
import styles from './About.module.css';

function About() {
  return (
    <div className={styles.aboutContainer}>
      <h1>About Page</h1>
      <p>Learn more about this app on the About page.</p>
    </div>
  );
}

export default About;
